import './ReferencesSection.css';
import ImageSlider from '../../components/ImageSlider/ImageSlider';
import Translator from '../../translates/Translator';
import hexes from '../../assets/img/hexes';

const ReferenceSection = () => {
    const t = Translator();

    const partnersDataSet = [
        {
            name: "Eptura",
            imgSrc: "eptura_logo.png"
        },
        {
            name: "ARCHIBUS",
            imgSrc: "archibus_logo.png"
        },
        {
            name: "archibus-hosting",
            imgSrc: "archibus_hosting_logo.jpg"
        },
        {
            name: "Keboola",
            imgSrc: "keboola_logo.png"
        },
        {
            name: "Sharry",
            imgSrc: "sharry_logo.png"
        },
        {
            name: "Mannai",
            imgSrc: "mannai_logo.png"
        },
        {
            name: "CVUT",
            imgSrc: "cvut_cz_logo.jpg"
        },
        {
            name: "AZURE",
            imgSrc: "azure_logo.png"
        },
        {
            name: "Autodesk",
            imgSrc: "autodesk_logo.png"
        },
    ]

    const referencesDataSet = [
        {
            name: "ČSOB",
            imgSrc: "CSOB_logo.png",
            alt: "ČSOB"
        },
        {
            name: "Skoda-Auto",
            imgSrc: "skoda_logo.png",
            alt: "Škoda Auto"
        },
        {
            name: "Kooperativa",
            imgSrc: "koop_logo.png",
            alt: "Kooperativa"
        },
        {
            name: "Ceska-posta",
            imgSrc: "ceskaposta_logo.png",
            alt: "Česka Pošta"
        },
        {
            name: "Masarykova-Univerzita",
            imgSrc: "muni_logo.png",
            alt: "Masarykova Univerzita"
        },
        {
            name: "Windmoller-Holscher",
            imgSrc: "windmuller_logo.png",
            alt: "Windmoller & Holscher"
        },
        {
            name: "Inex",
            imgSrc: "inex_logo.png",
            alt: "Inex"
        },
        {
            name: "aseta-group",
            imgSrc: "aseta_logo.png",
            alt: "Aseta Group"
        },
        {
            name: "Digiteq-Automotive",
            imgSrc: "digiteq_logo.png",
            alt: "Digiteq Automotive"
        },
        {
            name: "Surpmo",
            imgSrc: "surpmo_logo.png",
            alt: "Surpmo"
        },
        {
            name: "Siemens",
            imgSrc: "siemens_logo.png",
            alt: "Siemens"
        },
        {
            name: "vscr",
            imgSrc: "vscr_logo.png",
            alt: "VSČR"
        },
        {
            name: "saudi-aramco",
            imgSrc: "saudi_aramco_logo.jpg",
            alt: "Saudi Aramco"
        },
        {
            name: "qatar-foundation",
            imgSrc: "qatar_foundation_logo.png",
            alt: "Qatar Foundation"
        },
        {
            name: "Penta",
            imgSrc: "penta_logo.jpg",
            alt: "Penta"
        },
        {
            name: "Akeso",
            imgSrc: "akeso_logo.jpg",
            alt: "Akeso"
        }
    ]

    return (
        <div className='references warm-light-bg'>
            <img src={hexes.h3_80} className="hex3 o-50" alt='' />
            <h2 className='mb-2 mb-md-3'>{t("our-partners")}</h2>
            <h5 className='gray ls-less-1'>{t("our-partners-desc")}</h5>
            {/* <Row className='partners-panel shadow-8-2'>
                {partnersDataSet.map((image, i) => (
                    <img key={image.imgSrc + i}
                        src={`/reference_logos/${image.imgSrc}`}
                        alt={image.alt || `Logo ${i}`}
                        className="partner-img no-interaction"
                    />
                ))}
            </Row> */}
            <div className='partners-panel shadow-8-2'>
                <ImageSlider imgPath='/reference_logos/' images={partnersDataSet} />
            </div>
            <img src={hexes.h3_80} className="hex3 o-50" alt='' />

            <h2 className='mb-2 mb-md-3'>{t("our-clients")}</h2>
            <h5 className='gray ls-less-1'>{t("our-clients-desc")}</h5>
            <div className='clients-panel shadow-8-2'>
                <ImageSlider imgPath='/reference_logos/' images={referencesDataSet} grayscale={true}/>
            </div>
        </div>
    );
};

export default ReferenceSection;
